import checkResponse from "../helpers/responseService"
import axios from "axios";

export default {
  saveDataBatch(formData) {
    return axios.post('/data/batch', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => response)
      .catch(e => e.response)
      .then(response => checkResponse(response))
  }
}



// WEBPACK FOOTER //
// ./resources/js/services/batchDataService.js